module.exports = __webpack_public_path__ + "75b9a99931e8a1902a9470b5b23fb8c2.png";